/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { ElementRef, inject, Injectable } from "@angular/core";
import { SnackbarService } from "./snackbar.service";
import { Router } from "@angular/router";
import { NovuUI } from '@novu/js/ui';
import { Novu } from '@novu/js';

@Injectable({
    providedIn: "root",
})
export class NotificationService {
    appId = "fake";
    snackbar = inject(SnackbarService);
    router = inject(Router);

    constructor() {}

    setup(subscriberId: string, subscriberHash: string, novuInbox: ElementRef<HTMLElement>) {
        const novuUI = new NovuUI({
            options: {
                applicationIdentifier: this.appId,
                subscriberId,
                subscriberHash
            },
        });

        const novu = new Novu({
            applicationIdentifier: this.appId,
            subscriberId,
            subscriberHash
        });

        novu.on("notifications.notification_received", (data) => {
            if (data.result.tags?.includes("snackbar-error")) {
                if (data.result.subject) this.snackbar.errorPersistent(data.result.subject);
            } else if (data.result.tags?.includes("snackbar-warn")) {
                if (data.result.subject) this.snackbar.warnPersistent(data.result.subject);
            } else if (data.result.tags?.includes("snackbar-info")) {
                if (data.result.subject) this.snackbar.infoPersistent(data.result.subject);
            }
        })

        novuUI.updateTabs([
            { label: 'All' },
            {
                label: 'Notifications',
                filter: {
                    tags: ['notifications'],
                    data: {}
                }
            },
            {
                label: "News",
                filter: {
                    tags: ['news'],
                    data: {}
                }
            },
        ]);

        novuUI.updatePreferenceGroups([
            { name: 'Cluster Notifications', filter: { tags: ['cluster'] } },
            { name: 'Billing', filter: { tags: ['payments'] } },
            { name: 'News', filter: { tags: ['news'] } },
        ]);

        novuUI.updateRouterPush((url) => this.router.navigate([url]));

        novuUI.mountComponent({
            name: 'Inbox',
            element: novuInbox.nativeElement,
        });

        novuUI.updateAppearance({
            variables: {
                colorForeground: "#DEDEDE",
                colorBackground: "#151322",
                colorCounter: "#E96464",
                colorCounterForeground: "#DEDEDE",
                colorPrimary: "#78A0FF",
                colorPrimaryForeground: "#0E0D17",
                colorSecondary: "transparent",
                colorSecondaryForeground: "#958FA8",
                borderRadius: "8px",
                fontSize: "16px",
            },
        });
    }
}
